import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVocalMicrophone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconVocalMicrophone"><Path d="M15.501 12.5L6.57422 20.5771C5.69305 21.3744 4.34125 21.3402 3.50098 20.5C2.66071 19.6597 2.62658 18.3079 3.42383 17.4268L11.501 8.5L15.501 12.5ZM16.751 2.5C19.3743 2.5 21.501 4.62665 21.501 7.25C21.501 9.87335 19.3743 12 16.751 12C16.5614 12 16.3742 11.9884 16.1904 11.9668L12.0342 7.81055C12.0126 7.62672 12.001 7.43963 12.001 7.25C12.001 4.62666 14.1276 2.50002 16.751 2.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVocalMicrophone;
